export const environmentVariables = {
  homeUrl: process.env.REACT_APP_WFM_AVAILABILITY_UI_BASE_URL,
  wfmCommonApiUrl:process.env.REACT_APP_WFM_WFMCOMMON_BASE_URL,
  avlApiUrl: process.env.REACT_APP_WFM_AVAILABILITY_API_BASE_URL,
  envLevel: process.env.REACT_APP_ENVIRONMENT
};

export const constants = {
  OKTA_SSO: "http://localhost:1337/whoami",
  //API URL variables
  WFM_GET_UI_ENV_URLS:"ui-env",
  WFM_LOGOUT:"logout",
  WFM_GET_ALL_DIVISIONS_URL: "divisions/getAllDivisions",
  WFM_SERVER_TIME_URL: "divisions/getAllDivisions/get/038/servertime",
  CLGD_AVAIL_PERSON: "clgd/getPerson",
  WFM_AVAIL_PERSON: "wfmCommon/getPerson",
  WFM_AVAIL_FUTURE_PERSON: "wfmCommon/getFuture",
  WFM_COMMON_ISAPPACTIVE: "common/getIsAppActive",
  WFM_COMMON_GETALLAPPS: "common/getMyApps_SP",
  WFM_COMMON_GETALLEVENTS: "common/getMyEvents_SP",
  WFM_GET_EVENTS_BY_DIVNBR: "wfmEvent/getByDivNbr",
  WFM_GET_MY_EVENTS: "common/getMyEvents",
  WFM_GET_EVENT_DETAIL_BY_EVENTID: "common/getEventDetailsByEvtIdAssoc_SP",
  WFM_GET_EVENT_RESPONSE_DROP_DOWN: "common/getEventResponseDropdown_SP",
  WFM_ADD_BY_EVENT_ID_ASC_NBR_EVENT_DATE: "wfmEventResponses/addByEventIdAscNbrEventDate",
  WFM_UPDATE_BY_EVENT_ID_ASC_NBR_EVENT_DATE: "wfmEventResponses/updateByEventIdAscNbrEventDate",
  WFM_DELETE_BY_ASC_NBR_EVENT_DATE_EVENT_ID: "wfmEventResponses/deleteByAscNbrEventDateEventId",
  WFM_DELETE_BY_ASC_NBR_EVENT_ID: "wfmEventResponses/deleteByAscNbrEventId",
  WFM_UPDATE_EVENT_UNAVAILABLE_BY_ASC_NBR_EVENT_ID: "common/addEventResponse_All_No_SP",
  WFM_CALENDAR_GETTODAY: "fsccalender/today",
  WFM_CALENDAR_GETCALENDERDATE: "fsccalender",
  WFM_CALENDAR_NEXTMONTH:"fsccalender/nextfscmmbydate",
  WFM_CALENDAR_PREVMONTH:"fsccalender/prevfscmmbydate",
  WFM_GET_AVL_FIRST_EDIT_DATE:"common/getAvlFirstEditDate_SP",
  WFM_GET_EVENT_DETAILS_BY_EVT_ID_ASSOC:"common/getEventDetailsByEvtIdAssoc_SP",
  WFM_GET_WEEKS_IN_MONTH:"fsccalender/getWeeksInMthDate",
  WFM_UPDATE_RESET_EVENT_UNAVAILABLE_BY_ASC_NBR_EVENT_ID: "common/entireEventResponse_SP",
  WFM_GET_BASE_PAGE_DATA: "wfmAvailabilitySelection/getBasePageData",
  WFM_GET_AVAILABILITY_SELECTION_PAGE_DATA: "wfmAvailabilitySelection/getBasePageData",
  WFM_UPDATE_OR_INSERT_WD: "wfmAvailabilitySelection/updateOrInsertWeeklyData",
  WFM_RULES_BY_ID:"wfmAvailRules/getByRuleId",
  WFM_GET_DAILY_AVAIL_DROP_DOWN: "common/getAvlDailyResponseDropdown_SP",
  WFM_COMMON_GETAPPCONTROLS: "common/getAppControlsByAppDivLocDptWs_SP",
  WFM_GET_RULE_INFO: "common/getAvlCustomInfoMsg",
  WFH_COMMON_GET_MY_AVAILABILITY_RULES: "common/getMyAvailabilityRules_SP",
  WFM_UPDATE_INSERT_DAILY_DATA: "wfmAvailabilitySelection/updateOrInsertDailyData",
  WFM_GET_DIV_DETAIL_BY_DIVID: "divisions/getByDivId",
  WFM_GET_DIV_DETAIL_BY_DIVNBR: "divisions/getByDivNbr",
  WFM_GET_APP_BY_DIV_NBR: "app/getByDivNbr",
  WFM_RULES_BY_ARID:"wfmAvailRules/getByArId",
  WFM_GET_DIV_APP_LOC_CTL: "wfmAppControls/getByDivNbrAppAbbrLocNbrCltName",
  WFM_UPDATE_BY_CTL_ID: "wfmAppControls/updateByCtlId",
  WFM_DELETE_BY_APP_ID_AND_LOC_ID: "wfmAppControls/deleteByAppIdAndLocId",
  WFM_RULES_BY_ARID_CUTOFFDATE_BASEDATE: "wfmAvailRules/getByARIdCutOffDate",
  WFM_APP_CONTROL_ADD_NEW_CONTROL: "wfmAppControls/addNewControls",
  WFM_EVENT_CONTROL_GET_EVENT_DETAILS_ON_SEARCH_EVENT: "wfmEventControls/getEventDetailsOnSearchEvent",
  WFM_APP_CONTROL_ADD_BY_DIV_LOC_NBR_ABBR_CTLNAME: "wfmAppControls/addByDivNbrLocNbrAppAbbrCtlName",
  WFM_EVENT_CONTROL_GET_ADMIN_EVENT_CONTROLS_FOR_LOCATION:"wfmEventControls/getAdminEventControlsForLocation",
  WFM_EVENT_CONTROL_SAVE_ADMIN_EVENT_CONTROLS_FOR_LOCATION:"wfmEventControls/saveAdminEventControlsForLocation",
  WFM_COPY_FUTURE_WEEKS: "common/addCopyAvlToFuture_SP",
  WFM_EVENT_CONTROL_GET_EEVNT_CONTROL_LOCATION:"wfmEventControls/getAdminEventControlsWithLocCount",
  WFM_EVENT_ADD_BY_DIV_NBR_EVENT_NAME:"wfmEvent/addByDivNbrEventName",
  WFM_EVENT_UPDATE_BY_EVENT_ID:"wfmEvent/updateByEventId",
  WFM_DELETE_ADMIN_EVENT_LOCATION_CONTROLS_BY_EVENT_AND_LOCID:"wfmEventControls/deleteAdminEventLocationControlsByEventIdAndLocId",
  WFM_EVNT_CONTROLS_GET_EVENT_LOCATIONS: "wfmEventControls/getAdminEventControlLocationsByEventId",
  WFM_EVENT_GET_BY_DIV_NBR_EVENT_NAME:"wfmEvent/getByDivNbrEventName",
  WFM_DELETE_ADMIN_EVENT_CONTROLS_BY_EVENTID:"wfmEvent/deleteByEventId",
  WFM_DUPLICATE_ADMIN_EVENT_CONTROLS_BY_EVENTID_NAME:"wfmEvent/duplicateEvent",
  WFM_AVAILABILITY_WORK_SCHEDULE_ADMIN_SEARCH:"wfmAvailabilityWorkschedule/adminSearch",
  WFM_AVAILABILITY_WORK_SCHEDULE_ADD_NEW: "wfmAvailabilityWorkschedule/addNew",
  WFM_AVAILABILITY_WORK_SCHEDULE_EDIT_WORK_SCHEDULE: "wfmAvailabilityWorkschedule/editWorkschedule",
  WFM_AVAILABILITY_WORK_SCHEDULE_GET_WORK_SCHEDULES_BY_WSID: "wfmAvailabilityWorkschedule/getWorkschedulesByWsId",
  WFM_EVENT_CONTROL_BULK_UPDATE:"wfmEventControls/bulkUpdateEventControlsForAllLocations",
  WFM_AVL_RULE_ASSIGN_ADD: "wfmAvailRuleAssignments/addNew",
  WFM_AVLL_RULE_ASSIGN_UPDATE: "wfmAvailRuleAssignments/updateByAraId",
  WFM_AVLL_RULE_ASSIGN_DELETE: "wfmAvailRuleAssignments/deleteByAraId",
  WFM_AVLL_RULE_ASSIGN_GET_BY_A_RULEID: "wfmAvailRuleAssignments/getByAraId",
  WFM_AVLL_RULE_ASSIGN_SEARCH: "wfmAvailRuleAssignments/adminSearch",
  WFM_AVAILABILITY_PREFERENCE_GROUPS_ADMIN_DELETE:"wfmAppControls/deletePreferences",
  WFM_AVAILABILITY_PREFERENCE_GROUPS_ADMIN_UPDATE:"wfmAppControls/updatePreferences",
  WFM_AVAILABILITY_PREFERENCE_GROUPS_ADMIN_SEARCH:"wfmAppControls/searchPwhGrpNbrs",
  WFM_AVAILABILITY_WORK_SCHEDULE_DELETE_BY_WSID: "wfmAvailabilityWorkschedule/deleteByWsId",
  WFM_COMMON_ADVANCESEARCH: "common/advancedSearch",
  WFM_AVAILABILITY_LOCATION_CONTROLS_SEARCH:"wfmAppControls/searchAdminAppLocationControls",
  WFM_AVL_RULE_SEARCH: "wfmAvailRules/adminRuleSearch",
  WFM_AVL_RULE_GET_BY_RECORD_ID: "wfmAvailRules/getAdminAvailRulesByArId",
  WFM_AVL_RULE_ADD: "wfmAvailRules/addNew",
  WFM_AVL_RULE_UPDATE_BY_RECORD_ID: "wfmAvailRules/updateByArId",
  WFM_AVL_RULE_DELETE: "wfmAvailRules/deleteByArId",
  WFM_WFM_APP_CONTROL_GET_PREFRENCE_GROUPS:"wfmAppControls/getPreferenceAppControls",
  WFM_AVL_GET_ALL_WORKSCHEDULE:"wfmAvailabilityWorkschedule/getAllWorkschedules",
  WFM_SET_WEEKLY_AVAILABILITY_FROM_SLIDER: "wfmAvailabilitySelection/setWeeklyAvailabilityFromSlider",
  WFM_APP_CONTROL_ADD_EDIT_ADMIN_APP_LOCATION_CONTROLS:"wfmAppControls/addOrEditAdminAppLocationControls",
  WFM_APP_CONTROL_GET_ADMIN_APP_LOCATION_CONTROLS:"wfmAppControls/getAdminAppLocationControls",
  WFM_AVLL_CUT_OFF_CALENDAR_SEARCH: "wfmAvailCutoffCalendar/searchAdminCutoffCalendar",
  WFM_AVLL_CUT_OFF_CALENDAR_EDIT:"wfmAvailCutoffCalendar/editCutoffCalendar",
  WFM_AVLL_CUT_OFF_CALENDAR_ADD:"wfmAvailCutoffCalendar/addCutoffCalendar",
  WFM_CALENDAR_GET_FSC_YEARS: "fsccalender/getFscYears",
  WFM_APP_CONTROL_GET_LOCAL_CONTROLS_PREFERENCES:"wfmAppControls/searchLocationControlsPreferences",
  WFM_GET_WORKSCHEDULES_BY_RULEID: "wfmAvailabilityWorkschedule/getWorkschedulesByRuleId",
  WFM_DELETE_ADMIN_EVENT_LOCATION_CONTROLS_BY_DIV_AND_LOC: "wfmAppControls/deleteAppLocationControlsByDivNbrAppAbbrLocNbr",
  WFM_ACCOM_ADD_WFM_ACCOMODATIONS: "WfmAccommodation/adminAddWfmAccommodations",
  WFM_ACCOM_ADD_EDIT_WFM_ACCOMODATIONS: "WfmAccommodation/adminEditWfmAccommodations",
  WFM_ACCOM_GET_ADMIN_ACCOMODATIONS_BY_ID: "WfmAccommodation/getAdminAccommodationsById",
  WFM_ACCOM_SEARCH_ACCOMODATIONS_BY_ASSOCIATE: "WfmAccommodation/searchAccommodations",
  //WFM_AVL_CUTOFF_CAl_BY_DIV_NUMBER_ACTIVE:"wfmAvailCutoffCalendar/getByDivNbrActive",
  WFM_AVL_CUTOFF_CAl_BY_DIV_NUMBER_ACTIVE:"wfmAvailCutoffCalendar/getFutureEndByDivNbrActive",
  WFM_AVL_CUTOFF_CAl_BY_DIV_NUMBER_FSC_CAL_DATE:"wfmAvailCutoffCalendar/getByDivNbrAndFscCalDate",
  WFM_ACCOM_ADMIN_DELETE_WFM_ACCOMODATIONS: "WfmAccommodation/adminDeleteWfmAccommodations",
  WFM_GET_ALL_LANGUAGE_CODES: "language/getAllLanguageCodes",
  WFM_FILE_STATUS_HISTORY: "wfmECFileStatus/getAllStatuses",
  WFM_UPLOAD_FILES_BULK_ADD: "api/upload/files",
  WFM_DOWNLOAD_FILE: "api/download/file",
  WFM_COMMON_GET_SRS_DETAILS: "schedruleset",
  WFM_ACCOM_SAVE_UPDATED_TO_KRONOS : "addupdatescheduleoverride",
};                                                               
